export default "__VITE_ASSET__BpHfMG4S__"